import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdAppGroupPermissionSetsUpdatePermissionSetCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/app_group_permission_sets/all_permission_sets",
  "/companies/:company_id/app_group_permission_sets/permission_set/:id",
];
